import { Link } from 'react-router-dom'
import { ChevronRight, Home } from 'lucide-react'

interface BreadcrumbItem {
  label: string
  href?: string
  current?: boolean
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[]
  className?: string
}

export function Breadcrumbs({ items, className = '' }: BreadcrumbsProps) {
  return (
    <nav className={`flex ${className}`} aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2 text-sm">
        <li>
          <Link
            to="/"
            className="text-gray-500 hover:text-gray-700 transition-colors"
            aria-label="Home"
          >
            <Home className="h-4 w-4" />
          </Link>
        </li>
        
        {items.map((item, index) => (
          <li key={index} className="flex items-center">
            <ChevronRight className="h-4 w-4 text-gray-400 mx-2" />
            {item.href && !item.current ? (
              <Link
                to={item.href}
                className="text-gray-500 hover:text-gray-700 transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <span className={item.current ? 'text-gray-900 font-medium' : 'text-gray-500'}>
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}

// Helper function to generate breadcrumbs for different page types
export function generateBreadcrumbs(pathname: string, title?: string): BreadcrumbItem[] {
  const segments = pathname.split('/').filter(Boolean)
  const breadcrumbs: BreadcrumbItem[] = []

  if (segments.length === 0) {
    return []
  }

  // Handle different page types
  if (segments[0] === 'blog') {
    breadcrumbs.push({ label: 'Blog', href: '/blog' })
    
    if (segments.length > 1) {
      // Individual blog post
      breadcrumbs.push({ 
        label: title || 'Post', 
        current: true 
      })
    } else {
      // Blog listing page
      breadcrumbs[0].current = true
    }
  } else if (segments[0] === 'generator') {
    breadcrumbs.push({ label: 'Generator', current: true })
  } else if (segments[0] === 'verification') {
    breadcrumbs.push({ label: 'Verification', current: true })
  } else {
    // Content pages
    breadcrumbs.push({ 
      label: title || segments[0].replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase()), 
      current: true 
    })
  }

  return breadcrumbs
}
